<script setup>
import SettingsItem from "@/components/NewsPage/NewsPageAside/SettingsItem.vue";
import SettingsItemRegions from "@/components/NewsPage/NewsPageAside/SettingsItemRegions.vue";
import SettingsItemImportance from "@/components/NewsPage/NewsPageAside/SettingsItemImportance.vue";
import SettingsItemSentiment from "@/components/NewsPage/NewsPageAside/SettingsItemSentiment.vue";
import SettingsItemCategories from "@/components/NewsPage/NewsPageAside/SettingsItemCategories.vue";
import SettingsItemTags from "@/components/NewsPage/NewsPageAside/SettingsItemTags.vue";
import { useNewsFeedStore } from "@/store/NewsFeed/newsFeed";
import SettingsItemDate from "./NewsPageAside/SettingsItemDate.vue";
import { ref, provide } from "vue";
import { t } from "@/controllerLK/AvalLocalization";
import SettingsItemObject from "@/components/NewsPage/NewsPageAside/SettingsItemObject.vue";
import CrossIconBold from "@/components/Icons/CrossIconBold.vue";
import SettingsItemPoliticalAffiliation from "@/components/NewsPage/NewsPageAside/SettingsItemPoliticalAffiliation.vue";

const containerAside = ref(null);
provide("containerRef", containerAside);
const store = useNewsFeedStore();

const newsFeedStore = useNewsFeedStore();

const resetFilters = async () => {
  newsFeedStore.clearNewsFeed();
  newsFeedStore.clearFacet();
  await newsFeedStore.getNews();
};
</script>
<template>
  <aside
    id="containerAside"
    ref="containerAside"
    class="container-aside scroll"
  >
    <div class="container-aside__wrapper">
      <!--   Календарь   -->
      <SettingsItemDate />
      <!--   Города   -->
      <SettingsItem
        class="container-aside__item"
        :item="store.filterRegion"
        :component="SettingsItemRegions"
        :settings="true"
      />
      <!--   Значимость   -->
      <SettingsItem
        class="container-aside__item"
        :item="store.filterImportance"
        :component="SettingsItemImportance"
      />
      <!--   Тональность   -->
      <SettingsItem
        class="container-aside__item"
        :item="store.filterSentiment"
        :component="SettingsItemSentiment"
      />
      <!--   Категории   -->
      <SettingsItem
        v-if="0"
        class="container-aside__item"
        :item="store.filterCategories"
        :component="SettingsItemCategories"
      />
      <!--   Теги   -->
      <SettingsItem
        v-if="store.facetParams?.tags?.length"
        class="container-aside__item"
        :item="store.filterTags"
        :component="SettingsItemTags"
        :settings="true"
      />
      <!--   Политическая принадлежность.  -->
      <SettingsItem
        class="container-aside__item"
        :item="store.filterPoliticalAffiliation"
        :component="SettingsItemPoliticalAffiliation"
      />
      <!--   Объекты.  -->
      <SettingsItem
        id="settings-item-object"
        :item="store.filterObject"
        class="container-aside__item"
        :component="SettingsItemObject"
        :settings="true"
      />
    </div>
    <!--  Сброс    -->
    <div class="container-aside__reset">
      <ButtonRoundedPrimary
        class="container-aside__reset-button"
        size="small"
        @click="resetFilters"
      >
        {{ t('settings_reset.title') }}
        <CrossIconBold class="container-aside__reset-icon" />
      </ButtonRoundedPrimary>
    </div>
  </aside>
</template>
<style lang="scss" scoped>
.container-aside {
  padding: 0 5px 0 0;
  scrollbar-gutter: stable;
  position: relative;

  &__reset-button {
    width: 100%;
  }

  &__reset {
    display: flex;
    justify-content: center;
    align-items: center;
    position: sticky;
    bottom: 0;
    width: calc(100%);
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    background: #FFFFFF;
    height: 60px; // 30px (height) + 20px (padding) + 10px (gap)
    padding: 0 20px;
    z-index: 2;

    &-icon {
      width: 14px;
      height: 14px;
    }
  }

  &__wrapper {
    background: var(--background-bg-white);
    padding: 20px 20px 0 20px;
    display: flex;
    gap: 20px;
    flex-direction: column;
    min-height: 100%;
    height: max-content;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;

  }
}
</style>
